import React, { PropsWithChildren } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import type { SectionId } from '@/types';

function sectionFromPath(pathname: string): SectionId {
  if (pathname.startsWith('/artists')) return 'artists';
  if (pathname.startsWith('/workflow')) return 'workflow';
  if (pathname.startsWith('/analytics')) return 'analysis';
  return 'dashboard';
}

export const AppLayout: React.FC<PropsWithChildren<{ theme: string; toggleTheme: () => void }>> = ({ theme, toggleTheme }) => {
  const { pathname } = useLocation();
  const active = sectionFromPath(pathname);

  return (
    <div className="min-h-screen bg-body overflow-x-hidden">
      <div className="flex">
        <Sidebar activeSection={active} />
        <div className="flex-1">
          <main className="max-w-7xl mx-auto px-4 min-w-0 py-6 pb-20 lg:pb-6">
            <Outlet />
          </main>
        </div>
      </div>
      <BottomNav activeSection={active} />
    </div>
  );
};

export default AppLayout;
